module.exports = __webpack_public_path__ + "files/60f6e90ab1805aa095bc54d690682a58.png";